import React from "react";

import { TOPIC } from "App/Routes";
import GenericErrorPage from "components/ErrorPages/GenericError/GenericErrorPage";
import ChallengePage from "components/Challenge/ChallengePage";

import localize from "lang/localize";

class CustomChallengePage extends ChallengePage {
  /* Custom: removed renderStats() and renderButtons() */
  renderChallengeInfo() {
    if (this.props.locked) {
      return (
        <div className="pure-g innerblock">
          <div className="pure-u-sm-1-24" />
          <div className="pure-u-sm-22-24 topmargin-30">
            <GenericErrorPage
              routeUrl={TOPIC.format(this.props.lockedChallengeTopicId)}
              routeName={"“" + this.props.lockedChallengeTopicTitle + "”"}
              message={localize(
                "locked_challenge_with_route",
                this.props.language
              ).format(this.props.lockedChallengeTopicTitle)}
              language={this.props.language}
            />
          </div>
          <div className="pure-u-sm-1-24" />
        </div>
      );
    } else {
      return (
        <div>
          <div className="pure-g innerblock display-block">
            <div className="pure-u-sm-1-24" />
            <div className="pure-u-1-1 pure-u-sm-20-24">
              <div className="pure-u-sm-8-24 relative">
                {this.renderMedia()}
              </div>
              <div className="pure-u-sm-1-24" />
              <div className="pure-u-sm-15-24 topmargin-10">
                {this.renderText()}
              </div>
            </div>
            <div className="pure-u-sm-2-24 relative">
              {this.renderSideButtons()}
            </div>
            <div className="pure-u-sm-1-24" />
          </div>
        </div>
      );
    }
  }

  /* Custom: no <hr /> at the bottom, <p> has bottommargin-30 */
  renderText() {
    let footnoteAnchored = this.addAnchors(this.props.footnote);
    let titleAnchored = this.addAnchors(this.props.title);

    return (
      <div className="responsive-img-description">
        {this.props.challengeTypeId === 15 && (
          <p className="smalltext uppercase">
            {" "}
            {this.props.challengeMinigameTitle}{" "}
          </p>
        )}
        <h5 dangerouslySetInnerHTML={{ __html: titleAnchored }} />
        {!(this.props.challengeTypeId === 15) && (
          <p dangerouslySetInnerHTML={{ __html: footnoteAnchored }} />
        )}
        <p className="smalltext topmargin-30 bottommargin-30">
          {this.getRepeatText(this.props.repeat)}
          {this.getVideoDurationLimitText()}
        </p>
      </div>
    );
  }
}

export default CustomChallengePage;
